module.exports = __webpack_public_path__ + "img/approve.17d13591.svg";